import { debug, globalPageConfig, track } from 'lib';
import { getRtcStore } from 'widgets/lib/rtc/store';
import rtcUtils from 'widgets/lib/rtc/rtc-utils';
import assign from 'lodash/assign';

const logZego = debug.create('RTCZegoBase');
const logAgora = debug.create('RTCAgoraBase');

// 即构 rtc_type:5
// 声网 rtc_type:9

// 房间类型
export enum RoomTypeName {
  // 开播工具个播房间
  'pcClientRoom' = 'pcClientRoom',
  // web 个播
  'anchorRoom' = 'anchorRoom',
  // 派对厅
  'party' = 'party',
}

export enum RtcType {
  'agora' = 'agora',
  'zego' = 'zego',
}

// 初始化参数
export type IOptions = {
  roomId: string;
  userId: string;
  nickName: string;
  roomTypeName: RoomTypeName;
  streamId: string;
  // onLogin?: (isLogin: boolean) => void;
  onInitMusicInstance?: (isSuccess: boolean) => void;
  onPublishStateUpdate?: (isPublishing: boolean) => void;
  onPublishQualityUpdate?: (params: any) => void;
  onStopPublishingStream?: () => void;
  onSoundLevelUpdate?: (
    soundLevelList: { streamId: string; soundLevel: number }[],
  ) => void;
  onDestroy?: () => void;
};

export type IPreviewOptions = {
  // video?: HTMLVideoElement;
  // canvas?: HTMLCanvasElement;
  viewContainer: HTMLDivElement;
  videoInputName: string;
  // 是否是竖屏
  isPortrait?: boolean;
  hasVideo?: boolean;
  videoInput: string;
  audioInput: string;
  previewConfig?: any;
  success?: () => void;
  error?: () => void;
};

export type DeviceInfo = {
  deviceId: string;
  deviceName: string;
};

export type EncoderConfig = {
  width: number;
  height: number;
  captureWidth: number;
  captureHeight: number;
  frameRate: number;
  // bitRate: isTopc ? 800 : 100,
  bitRate: {
    minBitRate: number;
    maxBitRate: number; // isTopc?1200:200
  };
  audioBitRate: number;
  noiseSuppression: boolean;
  autoGainControl: boolean;
  echoCancellation: boolean;
};

export interface IRtcBase {
  /**
   * 初始化
   * @param options
   */
  init(options: IOptions): void;

  // 获取设备
  getDeviceList(): Promise<{
    cameras: DeviceInfo[];
    microphones: DeviceInfo[];
  }>;

  /**
   * 开始预览
   * @param opts
   * @param streamType 流类型
   */
  startPreview(opts: IPreviewOptions, streamType: string): void;

  rePreview(viewContainer: HTMLDivElement): void;

  // 停止预览
  stopPreview(): void;

  enableCamera(enable: boolean): void;

  enableMicrophone(enable: boolean): void;

  // 开始推流
  startPublishingStream(opts?: any): void;

  stopPublishingStream(): void;

  /**
   * 开始拉流
   * @param streamId
   * @param viewContainer
   * @param onFail
   * @param roomId
   */
  startPlayingStream(
    streamId: string,
    viewContainer: HTMLDivElement,
    onFail?: () => void,
    roomId?: string,
  ): () => void;

  /**
   * 停止流播放声音
   * @param streamId
   * @param mute
   * @param video
   * @param roomId
   */
  mutePlayStreamAudio(
    streamId: string,
    mute: boolean,
    video: HTMLVideoElement,
    roomId?: string,
  ): void;
  /**
   * 更新流编码
   * @param streamType
   * @param isJoinLive
   */
  updateStream(streamType: string, isJoinLive: boolean): void;

  destroy(): void;

  onLogin(isLogin: boolean): void;

  onPreviewed(isPreviewed: boolean): void;
}

class RtcBase {
  rtcType: string;

  trackName: string;

  options: IOptions;

  // 是否推流中
  isPublishing = false;

  // 是否已经预览
  isPreviewed = false;

  viewCanvas: HTMLCanvasElement;

  viewVideo: HTMLVideoElement;

  // 摄像头名
  videoInputName = '';

  isLogin = false;

  trackLog(event_type: string, content?: any, ...rest) {
    track.send({
      event: this.trackName,
      event_type,
      content,
    });
    if (this.rtcType === 'agora') {
      logAgora(event_type, content, ...rest);
    } else {
      logZego(event_type, content, ...rest);
    }
  }

  log(...rest) {
    if (this.rtcType === 'agora') {
      logAgora('info', ...rest);
    } else {
      logZego('info', ...rest);
    }
  }

  isRoomOwner(): boolean {
    return this.options.roomId === this.options.userId;
  }

  updateStream(streamType: string, isJoinLive: boolean) {
    getRtcStore().updateStreamType(streamType);
  }

  startPreview(opts: IPreviewOptions, streamType: string) {
    getRtcStore().updateStreamType(streamType);
    getRtcStore().currentRtcInfo.updateIsPortrait(opts.isPortrait);
  }

  rePreview(viewContainer: HTMLDivElement) {}

  onLogin(isLogin: boolean) {
    this.isLogin = isLogin;
    this.log('登录状态', isLogin);
    getRtcStore().updateLogin(isLogin);
  }

  onPreviewed(isPreview: boolean) {
    getRtcStore().currentRtcInfo.updatePreviewed(isPreview);
    this.log('预览状态', isPreview);
    this.isPreviewed = isPreview;
  }

  getEncoderConfig(streamType: string, videoInputName: string): EncoderConfig {
    let streamConfig = rtcUtils.getStreamConfig(streamType, videoInputName);

    // audio: true,
    //         audioInput,
    //         video: hasVideo,
    //         videoInput: videoInput || null,
    //         horizontal: true,
    //         videoQuality: 4,
    return assign(
      {
        width: 480,
        height: 640,
        frameRate: 25,
        // bitRate: isTopc ? 800 : 100,
        bitRate: {
          minBitRate: 400, // isTopc?800:100,
          maxBitRate: 1200, // isTopc?1200:200
        },
        audioBitRate: 48000,
        noiseSuppression: true,
        autoGainControl: true,
        echoCancellation: true,
      },
      globalPageConfig.getConfig().zgConfig || {},
      streamConfig,
    );
  }
}

export default RtcBase;
